import { render } from "./PlayerStatisticsTile.vue?vue&type=template&id=5e98c694"
import script from "./PlayerStatisticsTile.vue?vue&type=script&lang=js"
export * from "./PlayerStatisticsTile.vue?vue&type=script&lang=js"

import "./PlayerStatisticsTile.vue?vue&type=style&index=0&id=5e98c694&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__